import {BaseService} from './Core/BaseService';

class ForgotPasswordService extends BaseService {
    get Url() { return super.Url + "/forgotPassword"; }

    ResetPassword(token, password) {
        let request = {password: password};
        return this.SendRequest(BaseService.POST, request, token);
    }
}

export const service = new ForgotPasswordService();

